// Semantic, brand-aware color palette used across dashboards.
// Each category + status has its own accent color for quick scanning.
export const CATEGORY_COLORS = {
  Food:      { bg: "bg-orange-50",  text: "text-orange-700",  border: "border-orange-200",  dot: "bg-orange-500",  hex: "#f97316" },
  Travel:    { bg: "bg-sky-50",     text: "text-sky-700",     border: "border-sky-200",     dot: "bg-sky-500",     hex: "#0ea5e9" },
  Office:    { bg: "bg-violet-50",  text: "text-violet-700",  border: "border-violet-200",  dot: "bg-violet-500",  hex: "#8b5cf6" },
  Transport: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", dot: "bg-emerald-500", hex: "#10b981" },
  Lodging:   { bg: "bg-pink-50",    text: "text-pink-700",    border: "border-pink-200",    dot: "bg-pink-500",    hex: "#ec4899" },
  Other:     { bg: "bg-zinc-100",   text: "text-zinc-700",    border: "border-zinc-200",    dot: "bg-zinc-400",    hex: "#a1a1aa" },
};

export const CATEGORY_HEX_ARRAY = Object.values(CATEGORY_COLORS).map((c) => c.hex);

export const KPI_ACCENTS = {
  indigo:  { iconBg: "bg-indigo-50",  iconText: "text-indigo-600",  bar: "bg-indigo-500",  stripe: "from-indigo-400/0 via-indigo-400/60 to-indigo-500" },
  emerald: { iconBg: "bg-emerald-50", iconText: "text-emerald-600", bar: "bg-emerald-500", stripe: "from-emerald-400/0 via-emerald-400/60 to-emerald-500" },
  amber:   { iconBg: "bg-amber-50",   iconText: "text-amber-600",   bar: "bg-amber-500",   stripe: "from-amber-400/0 via-amber-400/60 to-amber-500" },
  rose:    { iconBg: "bg-rose-50",    iconText: "text-rose-600",    bar: "bg-rose-500",    stripe: "from-rose-400/0 via-rose-400/60 to-rose-500" },
  sky:     { iconBg: "bg-sky-50",     iconText: "text-sky-600",     bar: "bg-sky-500",     stripe: "from-sky-400/0 via-sky-400/60 to-sky-500" },
  violet:  { iconBg: "bg-violet-50",  iconText: "text-violet-600",  bar: "bg-violet-500",  stripe: "from-violet-400/0 via-violet-400/60 to-violet-500" },
};

// Avatar deterministic color
const AVATAR_PALETTE = [
  "bg-indigo-500",
  "bg-emerald-500",
  "bg-amber-500",
  "bg-rose-500",
  "bg-sky-500",
  "bg-violet-500",
  "bg-fuchsia-500",
  "bg-teal-500",
];
export function avatarColor(seed) {
  const s = String(seed || "").split("").reduce((a, c) => a + c.charCodeAt(0), 0);
  return AVATAR_PALETTE[s % AVATAR_PALETTE.length];
}
